// removed by extract-text-webpack-plugin
module.exports = {"root":"ParagraphMultipleImages-module-root-2DCh2","column":"ParagraphMultipleImages-module-column-3GT8c","caption":"ParagraphMultipleImages-module-caption-PGR3g","img":"ParagraphMultipleImages-module-img-25zDa","cta-wrap":"ParagraphMultipleImages-module-cta-wrap-2LpQk","ctaWrap":"ParagraphMultipleImages-module-cta-wrap-2LpQk"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/TechnicalDocument/components/ParagraphMultipleImages/ParagraphMultipleImages.module.scss
// module id = 1313
// module chunks = 0